<template>
  <b-container :style="fundoTopo" fluid id="topo">
    <div id="containerLogin" v-if="client === 'CUIABA'" class="d-block">
      <b-form id="formLogin" class="text-right">
        <b-col class="campoLogin" cols="12" sm="12" md="12" lg="12" xl="12">
          <b-form-group class="mb-0 mt-2">
            <a
              :href="baseLink"
              title="Login"
              target="_blank"
              class="btn px-md-3 py-md-2 mt-md-0 btn-primary"
            >
              Acessar Admin
            </a>
          </b-form-group>
        </b-col>
      </b-form>
    </div>
    <menuSite></menuSite>
    <destaque></destaque>
  </b-container>
</template>

<script>
  import menuSite from './menu.vue'
  import destaque from './destaque.vue'
  import MainData from '@/main.js'
  export default {
    name: 'Topo',
    data() {
      return {
        client: null,
        fundoTopo: ''
      }
    },
    created() {
      let me = this
      me.client = MainData.CLIENT
      if (me.client === 'CUIABA' || me.client === 'DOE-AL') {
        me.fundoTopo = { background: '#fff' }
      } else {
        me.fundoTopo = {
          backgroundImage:
            'url(' +
            require('@/assets/imagens/' + me.client + '/diariobg.jpg') +
            ')'
        }
      }
    },
    components: {
      menuSite,
      destaque
    },
    computed: {
      baseLink: function () {
        let link = MainData.APP_ENVIROMENT === 'prod' ? '/sispub' : '/admin'
        return link
      }
    }
  }
</script>

<style lang="scss">
  #topo {
    background-size: cover;
    background-position: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/topo.vue